<template lang="pug">

div

  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")
    .grid.is-small.is-middle
      .column.is-desktop-6
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/halx@2x.webp 2x, {CDN_URL}/ventures/halx.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/halx@2x.png 2x, {CDN_URL}/ventures/halx.png 1x', type: 'image/png' }]" ratio="2:1" :title="$t('halx')" :excerpt="$t('halxDesc')" url="/brands/halx" )
      .column.is-desktop-1
      .column.is-desktop-5
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/hostox@2x.webp 2x, {CDN_URL}/ventures/hostox.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/hostox@2x.png 2x, {CDN_URL}/ventures/hostox.png 1x', type: 'image/png' }]" ratio="1:1" :title="$t('hostox')" :excerpt="$t('hostoxDesc')" url="/brands/hostox" )

  section
    .grid.is-small.is-middle
      .column.is-desktop-2
      .column.is-desktop-4
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/nllo@2x.webp 2x, {CDN_URL}/ventures/nllo.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/nllo@2x.png 2x, {CDN_URL}/ventures/nllo.png 1x', type: 'image/png' }]" ratio="1:1" :title="$t('nllo')" :excerpt="$t('nlloDesc')" url="/brands/nllo" )
      .column.is-desktop-1
      .column.is-desktop-5
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/sbont@2x.webp 2x, {CDN_URL}/ventures/sbont.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/sbont@2x.jpg 2x, {CDN_URL}/ventures/sbont.jpg 1x', type: 'image/jpg' }]" ratio="2:1" :title="$t('sbont')" :excerpt="$t('sbontDesc')" url="/brands/sbont" )

  section
    .grid.is-small.is-middle
      .column.is-desktop-7
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/blexar@2x.webp 2x, {CDN_URL}/ventures/blexar.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/blexar@2x.png 2x, {CDN_URL}/ventures/blexar.png 1x', type: 'image/png' }]" ratio="3:2" :title="$t('blexar')" :excerpt="$t('blexarDesc')" url="/brands/blexar" )
      .column.is-desktop-1
      .column.is-desktop-4
        AppCard(:img="[{ srcset: '{CDN_URL}/ventures/azda@2x.webp 2x, {CDN_URL}/ventures/azda.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/azda@2x.png 2x, {CDN_URL}/ventures/azda.png 1x', type: 'image/png' }]" ratio="3:2" :title="$t('azda')" :excerpt="$t('azdaDesc')" url="/brands/azda" )


  section
    .grid.is-small.is-middle
      .column.is-desktop-5
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/hwanm@2x.webp 2x, {CDN_URL}/ventures/hwanm.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/hwanm@2x.jpg 2x, {CDN_URL}/ventures/hwanm.jpg 1x', type: 'image/jpg' }]" ratio="3:2" :title="$t('hwanm')" :excerpt="$t('hwanmDesc')" url="/brands/hwanm" )
      .column.is-desktop-1
      .column.is-desktop-6
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/mojz@2x.webp 2x, {CDN_URL}/ventures/mojz.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/mojz@2x.png 2x, {CDN_URL}/ventures/mojz.png 1x', type: 'image/png' }]" ratio="3:2" :title="$t('mojz')" :excerpt="$t('mojzDesc')" url="/brands/mojz" )

  section
    .grid.is-small.is-middle
      .column.is-desktop-7
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/nasj@2x.webp 2x, {CDN_URL}/ventures/nasj.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/nasj@2x.png 2x, {CDN_URL}/ventures/nasj.png 1x', type: 'image/png' }]" ratio="3:2" :title="$t('nasj')" :excerpt="$t('nasjDesc')" url="/brands/nasj" )
      .column.is-desktop-1
      .column.is-desktop-4
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/twzef@2x.webp 2x, {CDN_URL}/ventures/twzef.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/twzef@2x.png 2x, {CDN_URL}/ventures/twzef.png 1x', type: 'image/png' }]" ratio="1:1" :title="$t('twzef')" :excerpt="$t('twzefDesc')" url="/brands/twzef" )

  section
    .grid.is-small.is-middle
      .column.is-desktop-2
      .column.is-desktop-4
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/alsfwa@2x.webp 2x, {CDN_URL}/ventures/alsfwa.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/alsfwa@2x.png 2x, {CDN_URL}/ventures/alsfwa.png 1x', type: 'image/png' }]" ratio="1:1" :title="$t('alsfwa')" :excerpt="$t('alsfwaDesc')" url="/brands/alsfwa" )
      .column.is-desktop-1
      .column.is-desktop-5
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/creavs@2x.webp 2x, {CDN_URL}/ventures/creavs.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/creavs@2x.png 2x, {CDN_URL}/ventures/creavs.png 1x', type: 'image/png' }]" ratio="2:1" :title="$t('creavs')" :excerpt="$t('creavsDesc')" url="/brands/creavs" )

  section
    .grid.is-small.is-middle
      .column.is-desktop-7
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/usdy@2x.webp 2x, {CDN_URL}/ventures/usdy.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/usdy@2x.png 2x, {CDN_URL}/ventures/usdy.png 1x', type: 'image/png' }]" ratio="3:2" :title="$t('usdy')" :excerpt="$t('usdyDesc')" url="/brands/usdy" )
      .column.is-desktop-1
      .column.is-desktop-4
        AppCard(:img="[{ srcset: '{CDN_URL}/ventures/shbkat@2x.webp 2x, {CDN_URL}/ventures/shbkat.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/shbkat@2x.png 2x, {CDN_URL}/ventures/shbkat.png 1x', type: 'image/png' }]" ratio="3:2" :title="$t('shbkat')" :excerpt="$t('shbkatDesc')" url="/brands/shbkat" )


  section
    .grid.is-small.is-middle
      .column.is-desktop-5
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/obka@2x.webp 2x, {CDN_URL}/ventures/obka.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/obka@2x.png 2x, {CDN_URL}/ventures/obka.png 1x', type: 'image/png' }]" ratio="3:2" :title="$t('obka')" :excerpt="$t('obkaDesc')" url="/brands/obka" )
      .column.is-desktop-1
      .column.is-desktop-6
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/uxema@2x.webp 2x, {CDN_URL}/ventures/uxema.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/uxema@2x.jpg 2x, {CDN_URL}/ventures/uxema.jpg 1x', type: 'image/jpg' }]" ratio="3:2" :title="$t('uxema')" :excerpt="$t('uxemaDesc')" url="/brands/uxema" )

  section
    .grid.is-small.is-middle
      .column.is-desktop-7
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/rurs@2x.webp 2x, {CDN_URL}/ventures/rurs.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/rurs@2x.png 2x, {CDN_URL}/ventures/rurs.png 1x', type: 'image/png' }]" ratio="3:2" :title="$t('rurs')" :excerpt="$t('rursDesc')" url="/brands/rurs" )
      .column.is-desktop-1
      .column.is-desktop-4
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/basb@2x.webp 2x, {CDN_URL}/ventures/basb.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/basb@2x.png 2x, {CDN_URL}/ventures/basb.png 1x', type: 'image/png' }]" ratio="1:1" :title="$t('basb')" :excerpt="$t('basbDesc')" url="/brands/basb" )



  section
    .grid.is-small.is-middle
      .column.is-desktop-2
      .column.is-desktop-4
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/narx@2x.webp 2x, {CDN_URL}/ventures/narx.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/narx@2x.png 2x, {CDN_URL}/ventures/narx.png 1x', type: 'image/png' }]" ratio="1:1" :title="$t('narx')" :excerpt="$t('narxDesc')" url="/brands/narx" )
      .column.is-desktop-1
      .column.is-desktop-5
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/sellesa@2x.webp 2x, {CDN_URL}/ventures/sellesa.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/sellesa@2x.png 2x, {CDN_URL}/ventures/sellesa.png 1x', type: 'image/png' }]" ratio="2:1" :title="$t('sellesa')" :excerpt="$t('sellesaDesc')" url="/brands/sellesa" )

  section
    .grid.is-small.is-middle
      .column.is-desktop-7
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/fwasl@2x.webp 2x, {CDN_URL}/ventures/fwasl.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/fwasl@2x.png 2x, {CDN_URL}/ventures/fwasl.png 1x', type: 'image/png' }]" ratio="3:2" :title="$t('fwasl')" :excerpt="$t('fwaslDesc')" url="/brands/fwasl" )
      .column.is-desktop-1
      .column.is-desktop-4
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/oraj@2x.webp 2x, {CDN_URL}/ventures/oraj.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/oraj@2x.jpg 2x, {CDN_URL}/ventures/oraj.jpg 1x', type: 'image/jpg' }]" ratio="1:1" :title="$t('oraj')" :excerpt="$t('orajDesc')" url="/brands/oraj" )

  section
    .grid.is-small.is-middle
      .column.is-desktop-2
      .column.is-desktop-4
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/ords@2x.webp 2x, {CDN_URL}/ventures/ords.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/ords@2x.jpg 2x, {CDN_URL}/ventures/ords.jpg 1x', type: 'image/jpg' }]" ratio="1:1" :title="$t('ords')" :excerpt="$t('ordsDesc')" url="/brands/ords" )
      .column.is-desktop-1
      .column.is-desktop-5
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/afad@2x.webp 2x, {CDN_URL}/ventures/afad.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/afad@2x.jpg 2x, {CDN_URL}/ventures/afad.jpg 1x', type: 'image/jpg' }]" ratio="2:1" :title="$t('afad')" :excerpt="$t('afadDesc')" url="/brands/afad" )

  section
    .grid.is-small.is-middle
      .column.is-desktop-7
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/tsro@2x.webp 2x, {CDN_URL}/ventures/tsro.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/tsro@2x.jpg 2x, {CDN_URL}/ventures/tsro.jpg 1x', type: 'image/jpg' }]" ratio="3:2" :title="$t('tsro')" :excerpt="$t('tsroDesc')" url="/brands/tsro" )
      .column.is-desktop-1
      .column.is-desktop-4
        AppCard( :img="[{ srcset: '{CDN_URL}/ventures/cojora@2x.webp 2x, {CDN_URL}/ventures/cojora.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/cojora@2x.jpg 2x, {CDN_URL}/ventures/cojora.jpg 1x', type: 'image/jpg' }]" ratio="1:1" :title="$t('cojora')" :excerpt="$t('cojoraDesc')" url="/brands/cojora" )

  .u-mt-md
</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat brands",
    "pageDesc":"Discover Baianat sub brands contributing to various industries and read our brands development stories.",
    "mantra":"Our family of |brands.",
    "halx":"Halx",
    "halxDesc":"Because starting from a blank sheet is time consuming and blocking, we built our digital products store, Halx , to enhance designers' workflow with exclusive items.",
    "hostox":"Hostox",
    "hostoxDesc":"Thinking of what authentic hosting can do to business growth made us start Hostox. A hosting company that provides the latest in the industry at suitable prices with a customer support you can rely on.",
    "nllo":"Nllo",
    "nlloDesc":"Simplifying the ERP experience and providing a smarter tool for businesses to grow and track its work",
    "sbont":"Sbont",
    "sbontDesc":"Spend less time on projects with Sbont; our node.js framework that facilitates the coding process and gives developers a ready to implement code structure",
    "blexar":"Blexar",
    "blexarDesc":"Enabling fronted developers and designers to build rich web interfaces and digital experiences using a design system that serves as a CSS framework and supports modern user experience practices",
    "azda":"Azda",
    "azdaDesc":"Because business decisions should be based on data, we founded Azda to empower us and other companies around the globe with the needed analytics and insights through AI technology",
    "hwanm":"Hwanm",
    "hwanmDesc":"Our Arabian social network for women where they can find helpful information, exchange valuable tips and express their identity. ",
    "mojz":"Mojz",
    "mojzDesc":"Get the gist of the latest with Mojz. Read summarized news online so and stay up date easier with content that is free of fillers. ",
    "nasj":"Nasj",
    "nasjDesc":"Encouraging creative writers  with a platform that is specially made for those who have unique ideas to spread and need a platform with social flavor to express their identity. ",
    "twzef":"Twzef",
    "twzefDesc":"Creating a smarter solution for companies that need more than a recruitment talent pool, but an entire tracking software for their campaigns and processes. ",
    "alsfwa":"Alsfwa",
    "alsfwaDesc":"Reducing the headache of business setup and legal issues with a platform that provides companies and individuals with online consultations on critical matters. ",
    "creavs":"Creavs",
    "creavsDesc":"Gathering highlights and latest hacks in design, development, business and technology so teams can stay updated with the latest in field by one click. ",
    "usdy":"Usdy",
    "usdyDesc":"Revolutionizing self learning and providing students and knowledge seekers with authentic learning paths and valuable content both online and offline",
    "shbkat":"Shbkat",
    "shbkatDesc":"Because we know that our customers need authentic hosting, we founded Shbkat to provide trusted and affordable services in addition t domain services. ",
    "obka":"Obka",
    "obkaDesc":"A CMF created to help businesses and developers build smart, reliable and highly customized websites for E-commerce, task management and other different industries",
    "uxema":"Uxema",
    "uxemaDesc":"Making UXers work easier and adding more fun to their processes with a ready to use UX tools, templates and documents, that can be extracted in different formats and proposals",
    "rurs":"RURS",
    "rursDesc":"Providing marketers with tools, templates and resources so they can focus on getting innovative and worry less about organizing their ideas. ",
    "basb":"Basb",
    "basbDesc":"Stemming from our need for a simple task manager, Basb was created to help us stay productive and work as our internal social media. ",
    "narx":"Narx",
    "narxDesc":"Connecting businesses with their clients using instant and customized push notifications that goes through SMS, desktop apps, mobile apps or email",
    "sellesa":"Sellesa",
    "sellesaDesc":"Revolutionizing Ecommerce for business owners either they are startups or large businesses, so  they can build their online store and reach their customers in a more friendly way",
    "fwasl":"Fwasl",
    "fwaslDesc":"Enriching the online arabic content with technical articles translated by professionals in the fields of business, design, development and technology",
    "oraj":"Oraj",
    "orajDesc":"Picking the right gift could be tricky. Oraj helps you pick the perfect one and ship it anywhere around the world.",
    "ords":"Ords",
    "ordsDesc":"Making e commerce more pleasant through Ords. With variant categories and a rich blog that focuses sellers, it provides a great opportunity for business growth.",
    "afad":"Afad",
    "afadDesc":"Providing a consolidated learning experience for children is necessary for building an aware generation that’s why we founded Afad, an alternative learning platform for children.",
    "tsro":"Tsro",
    "tsroDesc":"Helping restaurants with their daily operation with Tsro POS that links front store services with the kitchen operations.",
    "cojora":"Cojora",
    "cojoraDesc":"Helping teams express their ideas visuualy with Cojora, a diagram system that enables team collaboration and brainstorming."
  },
  "ar": {
    "pageTitle":"علاماتنا التجارية",
    "pageDesc":"اكتشف قصص العلامات التجارية للمشاريع الفرعية الخاصة ببيانات التي تخدم في مختلف الصناعات وتعرف على قصة تطور كل واحد منها. ",
    "mantra":"عائلاتنا من العلامات |التجارية.",
    "halx":"هالكس",
    "halxDesc":"لأن البدء من ورقة فارغة ما هو إلا مضيعة للوقت و عرقلة للتفكير. قُمنا ببناء متجر المنتجات الرقمية هالكس، لتحسين مسار عمل المصممين بعناصر حصرية.",
    "hostox":"هوستوكس",
    "hostoxDesc":"فكر فيما يمكن أن تفعله استضافة موثوق بها في نمو الأعمال التجارية؟! جعلنا الأمر يبدأ من هوستوكس. شركة استضافة تقدم أحدث ما توصلت إليه الصناعة بأسعار مناسبة مع خدمة  دعم العملاء الذي يمكنك الاعتماد عليها.",
    "nllo":"نلو",
    "nlloDesc":"تبسيط تجربة تخطيط موارد المؤسسات وتوفير أداة أكثر ذكاءً للشركات للنمو وتتبع أعمالها.",
    "sbont":"سبونت",
    "sbontDesc":"اقضي وقتًا أقل في المشاريع مع سبونت. لدينا إطار node.js الذي يُسهل عملية البرمجة ويمنح المبرمجين استعدادًا لتنفيذ بنية التعليمات البرمجية.",
    "blexar":"بلكسر",
    "blexarDesc":"نُمكن مطورين Front-end والمصممين من إنشاء واجهات مواقع ثرية وتجارب رقمية  باستخدام نظام التصميم، الذي يعمل بمثابة إطار CSS ويدعم ممارسات تجربة المستخدم الحديثة.",
    "azda":"أذدا",
    "azdaDesc":"قرارات الأعمال التجارية يجب أن تعتمد على البيانات؛ لهذا أنشأنا أذدا لإمداد الشركات بالتحليلات والإحصائيات اللازمة من خلال تقنية الذكاء الاصطناعي.",
    "hwanm":"هوانم",
    "hwanmDesc":"شبكتنا الإجتماعية العربية الموجهة للنساء حيث يستطعن العثور على المعلومات المفيدة، و يتبادلن النصائح القيمة، ويعبّرن عن هويتهم.",
    "mojz":"موجز",
    "mojzDesc":"احصل على خلاصة وأحدث الأخبار مع موجز. اقرأ ملخص الأحداث الإخبارية على الإنترنت، وكُن على موعد مع محتوى سهل وخالي من الحشو.",
    "nasj":"نسج",
    "nasjDesc":"نشجع الكُتاب المبدعين من خلال منصة مُصممة خصيصًا لمْن يمتلكون أفكارًا فريدة للنشر، ويحتاجون إلى منصة ذات نكهة إجتماعية للتعبير عن هويتهم.",
    "twzef":"توظيف",
    "twzefDesc":"تحتاج الشركات إلى توظيف مجموعة جديدة من المواهب لديها كل فترة؛ لهذا أنشأنا حلًا ذكيًا يُمكنهم من تتبع حملات وعمليات التوظيف بسهولة.",
    "alsfwa":"الصفوة",
    "alsfwaDesc":"نوفر للشركات والأفراد منصة تجيب عن جميع الاستفسارات القانونية التي تشغل بالهم للحد من المشكلات التي تقابلهم أثناء تأسيس أعمالهم التجارية.",
    "creavs":"كريفز",
    "creavsDesc":"نجمع لك أهم النصائح والمعلومات في مجالات التصميم والبرمجة والأعمال التجارية والتكنولوجيا، مما يساعدك على الإطلاع على أحدث التفاصيل بنقرة واحدة.",
    "usdy":"يسدي",
    "usdyDesc":"نسعى إلى تغيير طريقة التعلم الذاتي، وتزويد الطلاب والباحثين بالمعلومات التي يحتاجون إليها، من خلال مسارات تعلم استراتيجية ومحتوى قيّم سواء أونلاين أو أوفلاين.",
    "shbkat":"شبكات",
    "shbkatDesc":"نعلم أن عملائنا بحاجة إلى إستضافة موثوق بها. لهذا، أسسنا شبكات لتوفير خدمة  إستضافة متميزة بالإضافة إلى خدمة  النطاقات.",
    "obka":"أوبكا",
    "obkaDesc":"بدأنا أوبكا ليكون CMF يساعد الشركات والمبرمجين في إنشاء المواقع و المتاجر الالكترونية و تخطيط موارد المؤسسة وغيرها من الصناعات المختلفة.",
    "uxema":"يوكسيما",
    "uxemaDesc":"نجعل عمل مطوري تجربة المستخدم أسهل ونضيف المزيد من المرح إلى عملياتهم، باستخدام أدوات وقوالب ومستندات، جاهزة للاستخدام حيث يمكن استخراجها في أشكال وعروض مختلفة.",
    "rurs":"رورز",
    "rursDesc":"نُزود  المسوقين بالأدوات والنماذج والموارد ليتمكنوا من التركيز والابتكار،  وتنظيم أفكارهم بعيدًا عن القلق بشأن هذه الأدوات .",
    "basb":"باسب",
    "basbDesc":"انطلاقاً من حاجتنا إلى مدير مهام بسيط، تم إنشاء شركة باسب لمساعدتنا على المحافظة على الإنتاجية والعمل كوسيلة  تواصل اجتماعية داخلية.",
    "narx":"ناركس",
    "narxDesc":"نساعدك للتواصل مع عملائك باستمرار عن طريق الإشعارات المخصصة التي تصل إليهم عبر خدمة الرسالة القصيرة و تطبيقات سطح المكتب وتطبيقات الجوال و البريد الإلكتروني.",
    "sellesa":"سليسا",
    "sellesaDesc":"طورنا سليسا لتمكين أصحاب الأعمال التجارية من بناء متاجرهم على الإنترنت والوصول إلى عملائهم بطريقة أكثر ذكاءً.",
    "fwasl":"فواصل",
    "fwaslDesc":"نُثري المحتوى العربي على الإنترنت بالمقالات التقنية في مجالات الأعمال والبرمجة والتصميم و التكنولوجيا.",
    "oraj":"أوراج",
    "orajDesc":"اختيار الهدية الملائمة لكل مناسبة يكون صعبًا، أوراج يساعدك على اختيار الهدية المناسبة ويمكنك من شحنها إلى أي مكان في العالم.",
    "ords":"أوردس",
    "ordsDesc":"اجعل التجارة الإلكترونية أكثر متعة وسهولة من خلال أوردس، من خلال فئات متنوعة ومدونة غنية تركز على البائعين وبذلك يوفر فرصة رائعة لنمو الأعمال.",
    "afad":"أفاد",
    "afadDesc":"فكرنا في إنشاء أفاد من أجل توفير منصة تعليمية بديلة تقدم تجربة موحدة للأطفال لخلق جيل لديه الوعي الكافي من أجل تغيير المستقبل.",
    "tsro":"تسرو",
    "tsroDesc":"نساعد المطاعم في أداء عملياتهم من خلال تسرو نظام لنقاط البيع الذي يربط ما بين المتجر الأمامي وبين المطبخ لسهولة الإدارة وتقديم طلبات مميزة.",
    "cojora":"كوجورا",
    "cojoraDesc":"نساعد الفرق على العمل والتعاون سويًا والتعبير عن أفكارهم بشكل مرئي من خلال كوجورا حيث يوفر نظام للمخططات والرسومات البيانية."
  }
}
</i18n>
